import { GetLuckyWheelResponse } from '@/modules/promotion/type'
import { columns } from './constants'
import { DataTable } from '@/common/ui/table/data-table'

interface LuckyWheelTableProps {
	data: GetLuckyWheelResponse[]
	isLoading?: boolean
}

const formatConstraint = (constraint: {
	constraintType: string
	operator?: string
	amount: number
}) => {
	const ComparisionOperator: Record<string, string> = {
		GREATER_THAN: 'มากกว่า',
		GREATER_THAN_OR_EQUAL: 'มากกว่าหรือเท่ากับ',
	}

	const typeMap: Record<string, string> = {
		LOSS_AMOUNT: 'ยอดเสีย',
		DEPOSIT_AMOUNT: 'ยอดฝาก',
		TURNOVER: 'เทิร์นโอเวอร์',
	}

	return `${typeMap[constraint.constraintType] || constraint.constraintType} ${constraint.operator ? `${ComparisionOperator[constraint.operator] || constraint.operator} ` : ''}${constraint.amount}`
}

export default function LuckyWheelTable({
	data,
	isLoading,
}: LuckyWheelTableProps) {
	const flattenedData = data.flatMap(
		(item) =>
			item.wheelSetting?.map((setting) => ({
				...setting,
				luckyWheelId: item.id,
				isActive: item.isActive,
				expiredIn: item.expiredIn,
			})) || [],
	)

	return (
		<div className="space-y-4">
			<div className="flex flex-wrap items-center gap-4">
				<span className="">เงื่อนไขในการหมุนกงล้อ:</span>
				{data[0]?.claimConstraint?.length ? (
					data[0].claimConstraint.map((constraint, index) => (
						<span key={index} className="text-sm">
							{formatConstraint(constraint)}{' '}
							{index === data[0].claimConstraint.length - 1 ? '' : 'หรือ'}
						</span>
					))
				) : (
					<span className="text-sm text-muted-foreground">ไม่มีเงื่อนไข</span>
				)}
			</div>

			<DataTable columns={columns} data={flattenedData} isLoading={isLoading} />
		</div>
	)
}
